import { createContext, useCallback, useEffect, useState } from "react";
import Axios from "axios";
import UrlLinks from "../UrlLinks";
import { ScaleLoader } from "react-spinners";

export const AppData = createContext(null);

function Context({ children }) {
  const [formMode, setFormMode] = useState("create");
  const [mpaFormMode, setMpaFormMode] = useState("create");
  const [jobConfigMode, setJobConfigMode] = useState("create");
  const [eligibilityMode, setEligibilityMode] = useState("create");
  const [eligibilityJobId, setEligibilityJobId] = useState(null);
  const [userAction, setUserAction] = useState(null);
  const [eligibilityOptionList, setEligibilityOptionList] = useState({
    assetList: [],
    documentList: [],
    educationList: [],
    experienceList: [],
    genderList: [],
    languageList: [],
    shiftTimings: [],
    skillList: [],
  });

  /* Trades the stored refresh token for a fresh hiring flow token */
  const refreshHiringFlowToken = useCallback(async () => {
    const refreshToken = localStorage.getItem("hiringFlowRefreshToken");
    if (!refreshToken) {
      return null;
    }
    const response = await Axios.post(
      UrlLinks.hiringFlow.hiringFlowRefreshUrl,
      { refreshToken },
      { headers: { "Content-Type": "application/json" } }
    );
    const newToken = response.data?.response?.token || response.data?.token;
    const newRefreshToken =
      response.data?.response?.refreshToken || response.data?.refreshToken;
    if (newToken) {
      localStorage.setItem("hiringFlowToken", newToken);
    }
    if (newRefreshToken) {
      localStorage.setItem("hiringFlowRefreshToken", newRefreshToken);
    }
    return newToken;
  }, []);

  useEffect(() => {
    const storedUserActions = JSON.parse(
      localStorage.getItem("userActions") || "{}"
    );

    setUserAction({
      view:
        localStorage.getItem("roleType") === "31" ||
        localStorage.getItem("roleType") === "6"
          ? 1
          : +storedUserActions?.view,
      edit:
        localStorage.getItem("roleType") === "31" ||
        localStorage.getItem("roleType") === "6"
          ? 1
          : +storedUserActions?.edit,
      approveReject:
        localStorage.getItem("roleType") === "31" ||
        localStorage.getItem("roleType") === "6"
          ? 1
          : +storedUserActions?.addOrDelete,
      export_access:
        localStorage.getItem("roleType") === "31" ||
        localStorage.getItem("roleType") === "6"
          ? 1
          : +storedUserActions?.export_access,
    });
  }, []);

  const Loader = () => (
    <div
      style={{
        margin: "auto",
        width: "100%",
        height: "100%",
        marginTop: "25%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  return (
    <AppData.Provider
      value={{
        Loader,
        formMode,
        setFormMode,
        mpaFormMode,
        setMpaFormMode,
        jobConfigMode,
        setJobConfigMode,
        eligibilityMode,
        setEligibilityMode,
        eligibilityJobId,
        setEligibilityJobId,
        userAction,
        setUserAction,
        eligibilityOptionList,
        setEligibilityOptionList,        
        refreshHiringFlowToken,
      }}
    >
      {children}
    </AppData.Provider>
  );
}

export default Context;
